export default {
  statsBox:
    'flex flex-wrap justify-between items-center gap-x-2 gap-y-1 font-semibold text-[13px]',
  linkBox:
    'text-[#026EA1] font-semibold text-[13px] [&>a]:inline-flex [&>a]:flex-wrap [&>a]:items-center [&>a]:gap-1',
};

export const requireHistory = {
  usernameTypo:
    'text-black text-sm! font-medium! leading-8! tracking-[0.15px]!',
  amount: 'text-black text-sm! leading-8! tracking-[0.15px]!',
  details: 'text-black text-sm!',
  cancelIcon: 'text-[#B00020]',
};
